module.exports = __webpack_public_path__ + "img/turbo-features11.25def116.png";